import React, {useCallback, useState} from 'react';
import {Box, Container, Tab, Tabs} from '@mui/material';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {useParams} from 'react-router-dom';
import {useAppSelector} from '../../store/hooks';
import FullScreenLoadingSpinner from '../shared/FullScreenLoading';
import PageTitle from '../shared/PageTitle';
import TeamPlayerSessionsReport from '../TeamReports/TeamPlayerSessionsReport';
import TeamSessionsReport from '../TeamReports/TeamSessionsReport';

interface Props {}

const TeamExport: React.FC<Props> = () => {
  const {t} = useTranslation();
  const currentState = useAppSelector(state => ({
    team: state.team,
    family: state.family,
  }));
  const preferredUnits = useAppSelector(
    state => state.profile.profile?.preferredUnits,
  );

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = useCallback(
    (_event: React.SyntheticEvent, newValue: number) => {
      setTabIndex(newValue);
    },
    [],
  );

  const {teamId} = useParams();
  const teamIdInt = parseInt(teamId || '');

  const activeTeam = (currentState?.team?.teams ?? []).filter(
    team => team.id === teamIdInt,
  );

  const title = t('navigation.pageTitle', {pageName: t('pages.teamExport')});

  if (currentState.team?.status === 'loading' || activeTeam.length !== 1) {
    return (
      <>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <FullScreenLoadingSpinner />
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Container>
        <PageTitle>{t('pages.teamExport')}</PageTitle>
        <Box sx={{borderBottom: 1, borderColor: 'divider', mb: 2}}>
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab label={t('pages.playerSessions')} />
            <Tab label={t('pages.teamSessions')} />
          </Tabs>
        </Box>

        <Box hidden={tabIndex !== 0}>
          <TeamPlayerSessionsReport
            players={activeTeam[0]?.players ?? []}
            preferredUnits={preferredUnits}
          />
        </Box>

        <Box hidden={tabIndex !== 1}>
          <TeamSessionsReport
            teamId={teamIdInt}
            teamName={activeTeam[0]?.name ?? ''}
          />
        </Box>
      </Container>
    </>
  );
};

export default React.memo(TeamExport);
